import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

export default function useGetMySkillsInAdmin() {
  const { id } = useParams();
  return useQuery(['employee-skills-in-admin'], async () => {
    const response = await makeApiRequest.get(
      createQueryParamsForGetReq(apiEndPoints.MY_SKILLS_API, {
        employee_id: id,
      })
    );

    return response.data;
  });
}
